/**
 * SophIA Footer Component
 * Displays version, creation date, and links
 */

const APP_INFO = {
  name: "SophIA",
  version: "1.8.7",
  created: "25 Mars 2026, 21h30",
  lastUpdate: "27 Mars 2026",
  author: "Emergent Labs",
  url: "https://soph-ia.org"
};

const Footer = ({ minimal = false }) => {
  if (minimal) {
    return (
      <footer className="text-center text-xs text-[#94A3B8] py-4">
        <a href={APP_INFO.url} className="hover:text-[#1A365D]">{APP_INFO.name}</a>
        {" "}v{APP_INFO.version} • {APP_INFO.created}
      </footer>
    );
  }

  return (
    <footer className="text-center text-xs text-[#94A3B8] py-4 space-y-1">
      <div>
        <a href={APP_INFO.url} className="hover:text-[#1A365D] font-medium">{APP_INFO.name}</a>
        {" "}- Professeur de Philosophie Virtuel 24/7
      </div>
      <div className="flex items-center justify-center gap-2 flex-wrap">
        <span>v{APP_INFO.version}</span>
        <span>•</span>
        <span>Créé en {APP_INFO.created}</span>
        <span>•</span>
        <span>Mis à jour le {APP_INFO.lastUpdate}</span>
      </div>
      <div className="flex items-center justify-center gap-3 pt-1">
        <a href="/demo" className="text-[#D4AF37] hover:underline">Demander une démo</a>
        <span>•</span>
        <a href="/admin" className="hover:text-[#1A365D]">Admin</a>
        <span>•</span>
        <a href="/about" className="hover:text-[#1A365D]">Qui sommes-nous</a>
        <span>•</span>
        <a href="/legal" className="hover:text-[#1A365D]">Mentions légales</a>
      </div>
    </footer>
  );
};

// Export version info for use elsewhere
export const VERSION = APP_INFO.version;
export const APP_NAME = APP_INFO.name;

export default Footer;
